import type { RouterConfig } from '@nuxt/schema';

// Own scroll reset under the opaque cover — never scroll the live page on route change.
export default <RouterConfig>{
    scrollBehavior() {
        return false;
    }
};
